import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
const getTypographyStyle = (variant) => {
    switch (variant) {
        case "section":
            return "typography.headline.22.bold";
        case "main":
            return "typography.headline.24.bold";
    }
};
export const Title = ({ title, variant, testId, heading = "h2", hasMargin = true, }) => {
    const typography = getTypographyStyle(variant);
    if (!title)
        return null;
    return (_jsx(Box, { as: heading, marginTop: "0", marginBottom: hasMargin ? "spacing.24" : "0", testId: testId, typography: typography, children: title }));
};
